export default Object.freeze({
    PRACTICE: 'practice',
    NETWORK: 'network',
    REFERRAL_CREATION: 'referral_creation',
})
